import {
    Component,
    Injectable,
    Input,
    OnInit,
    ElementRef,
    AfterViewInit,
    Output,
    EventEmitter,
    Renderer2
} from '@angular/core';
import moment from 'moment-mini';
import {PointsModalService} from '../../services/points-modal.service';
import {ClipService} from '../../services/clip.service';
import {RewardsSummaryService} from '../../services/rewards-summary.service';
import {RewardModel} from '../../models/data.model';
import {UnclipRewardModel} from '../../models/data.model';
import {RewardsToasterArgs, RewardsToasterType} from '../../services/rewards-toaster.interface';
import {RewardsToasterService} from '../../services/rewards-toaster.service';
import {AuthService} from "../../services/auth.service";

// jQuery
declare var $: any;

function _window(): any {
    return window;
}

@Component({
    selector: "points-child-modal",
    templateUrl: "./points-child-modal.component.html",
    styleUrls: ['./points-child-modal.component.scss'],
})
@Injectable()
export class PointsChildModalComponent implements OnInit, AfterViewInit {
    @Input() type;
    @Input() reward;
    @Input() cancelRedemptionButton;
    @Input() disabledButton: boolean = false;
    @Input() rewardPageType;
    @Input() showPointsScoreCard = false;
    @Input() cssSizeChange = false;
    @Input() isGetYourRewardFlow: boolean;
    @Output() callMyListApi= new EventEmitter();
    public modal: any = {
        title: "",
        titleBorder: false,
        id: "",
        modalClass: "",
        isRewardsSelected: false,
        isRewardsRedemption: false,
        isBoxtop: false,
        isServiceDetails: false,
        type: '',
        actionButton: '',
        reward: {},
        rewardId: '',
        displayRedemptionButton: true,
        titleId: "",
        describedId: "",
        isRefresh: false,
        isSafeToClose: true,
    };
    public rewardsSelected: RewardModel[] = [];
    public rewardsUnclip: UnclipRewardModel[] = [];
    public rewardHistoryDisabled = false;
    public rewardUnclipDisabled = false;
    @Input() rewardNewRefreshDisabled: boolean;
    private detailPath: String = '';
    public rewardDetailPath: String = '';
    public sm = '575px';
    public md = '768px';
    private imagePath: string = window['AB']['dMTProductCard'];
    public disableMulticlipRewardGallery: boolean;
    public disableToastmessageRewardPage: boolean;
    public enableNewRewardModalBtnUI: boolean;
    public rewardsAvailable: number;
    public rewardPoints: number;
    public rewardsExpire: number;
    @Output() sendNoteToRefreshRewards = new EventEmitter();
    @Input() userInfo;
    @Input() currentEnvironment;
    @Input() appHostURL;
    @Input() pointsAvailable;
    @Output() clipInProgressForDetailsPage = new EventEmitter();
    isClipInProgress: boolean = false;

    public constructor(
        public elementRef: ElementRef,
        private _pointsModalService: PointsModalService,
        private couponClipFn: ClipService,
        private _rewardsSummaryService: RewardsSummaryService,
        private _rewardsToasterService: RewardsToasterService,
        private _renderer: Renderer2,
        private authService: AuthService
    ) {
        this.rewardHistoryDisabled = false;
        this.rewardUnclipDisabled = false;
        this.disableMulticlipRewardGallery = false;
        this.disableToastmessageRewardPage = false;
        this.enableNewRewardModalBtnUI = true;

    }

    public ngOnInit() {

        this.disabledButton = false;
        this.reward.detailPath = '/content/www/safeway/en/foru/rewards/reward-details';
        this.rewardDetailPath = this.reward.detailPath + '.' + this.reward.groceryRewardId + '.html';
        this.modal.type = this.type;
        this.modal.reward = this.reward;
        this.modal.isRefresh = false;
        if (this.cancelRedemptionButton == true) this.modal.displayRedemptionButton = false;
        if (this.modal.type == "rewards-redemption") {
            //this.modal.title=`${ this.modal.reward.rewardsRequired } ${this.modal.reward.rewardsRequired == 1 ? "Reward" : "Rewards"} will be used for:`;
            this.modal.title = 'Confirm';
            this.modal.id = "rewards-redemption-confirmation-modal-" + this.modal.reward.groceryRewardId;
            this.modal.actionButton = "Redeem";
            if (this.showPointsScoreCard) {
                this.modal.actionButton = "Use " + this.reward.pointsRequired + " pts"
            }
            this.modal.titleBorder = false;
            this.modal.isRewardsRedemption = true;
            this.modal.titleId = "rewards-redemption-title-id" + this.modal.reward.groceryRewardId;
            this.modal.describedId = "rewards-redemption-described-id" + this.modal.reward.groceryRewardId;
            this.modal.disableConfirmButtonID = '';
        }
        if (this.modal.type == "rewards-redemption-multiclip") {
            //this.modal.title=`${ this.modal.reward.rewardsRequired } ${this.modal.reward.rewardsRequired == 1 ? "Reward" : "Rewards"} will be used for:`;
            this.modal.title = 'Confirm';
            this.modal.id = "rewards-redemption-confirmation-modal-" + this.modal.reward.groceryRewardId;
            this.modal.actionButton = "multiclip";
            this.modal.titleBorder = false;
            this.modal.isRewardsRedemption = true;
            this.modal.titleId = "rewards-redemption-title-id" + this.modal.reward.groceryRewardId;
            this.modal.describedId = "rewards-redemption-described-id" + this.modal.reward.groceryRewardId;
            this.modal.disableConfirmButtonID = '';
        }
        if (this.modal.type === 'points-rewards-redemption') {
            // this.modal.title=`${ this.modal.reward.rewardsRequired } ${this.modal.reward.rewardsRequired == 1 ? "Reward" : "Rewards"} will be used for:`;
            this.modal.title = '';
            this.modal.id = 'points-rewards-redemption-confirmation-modal-' + this.modal.reward.groceryRewardId;
            this.modal.actionButton = 'Redeem';
            if (this.showPointsScoreCard) {
                this.modal.actionButton = "Use " + this.reward.pointsRequired + " pts"
            }
            this.modal.titleBorder = false;
            this.modal.isRewardsRedemption = true;
            this.modal.titleId = 'points-rewards-redemption-title-id' + this.modal.reward.groceryRewardId;
            this.modal.describedId = 'points-rewards-redemption-described-id' + this.modal.reward.groceryRewardId;
            this.modal.disableConfirmButtonID = '';
        }
        if (this.modal.type === 'points-rewards-redemption-multiclip') {
            // this.modal.title=`${ this.modal.reward.rewardsRequired } ${this.modal.reward.rewardsRequired == 1 ? "Reward" : "Rewards"} will be used for:`;
            this.modal.title = '';
            this.modal.id = 'points-rewards-redemption-confirmation-modal-' + this.modal.reward.groceryRewardId;
            this.modal.actionButton = 'multiclip';
            this.modal.titleBorder = false;
            this.modal.isRewardsRedemption = true;
            this.modal.titleId = 'points-ewards-redemption-title-id' + this.modal.reward.groceryRewardId;
            this.modal.describedId = 'points-rewards-redemption-described-id' + this.modal.reward.groceryRewardId;
            this.modal.disableConfirmButtonID = '';
        }
        this.couponClipFn.disableAllButtonsObservable.subscribe(state => {
            this.disabledButton = state;
        });
    }

    public ngAfterViewInit() {
        // window['AB']['ARIA'].rewardsModalFocus(this.modal.id);
        let modalId = this.modal.id;
        let modalTitleId = this.modal.titleId;
        let check = false;
        let focusId = null;
        let rewards = [];
        let rewardIndex = 0;

        //rewards redemption modals
        if (this.modal.type == "rewards-redemption" || this.modal.type == "rewards-redemption-multiclip") {
            //on shown rewards redemption modal
            $("#" + this.modal.id).on('shown.bs.modal', function () {
                $("#" + modalId).attr('aria-hidden', 'false');

                //If cancel or x is hit, clear rewardFocus from localStorage//
                $('.modal-cancel, .modal-x').click(function () {
                    localStorage.setItem('rewardFocus', '');
                })

                //Get next focusable element//
                check = false;
                focusId = null;
                rewards = [];
                rewardIndex = 0;
                $('.reward-use-btn').each(function () {
                    rewards[rewardIndex] = $(this).data('focus');
                    rewardIndex++;

                    if (check == true && !focusId) {
                        focusId = $(this).data('focus');
                        localStorage.setItem("rewardFocus", focusId);
                    }

                    if ($(this).data('focus') == modalTitleId) {
                        check = true;
                    }
                })

                $('.multiclipCLipRewardBtn').each(function () {
                    rewards[rewardIndex] = $(this).data('focus');
                    rewardIndex++;

                    if (check == true && !focusId) {
                        focusId = $(this).data('focus');
                        localStorage.setItem("rewardFocus", focusId);
                    }

                    if ($(this).data('focus') == modalTitleId) {
                        check = true;
                    }
                })

                if (!focusId) {
                    localStorage.setItem("rewardFocus", rewards[rewardIndex - 2]);
                }
            });
            $("#" + this.modal.id).on('hidden.bs.modal', function () {
                $("#" + modalId).attr('aria-hidden', 'true');
            });
        }
    }

    public clipReward() {
        // this.disabledButton = true;
        this.modal.reward.isConfirmModalButtonDisabled = true;
        this.couponClipFn.clipReward(this.modal.reward, this.updateStatistics.bind(this), this.rewardNewRefreshDisabled, this.userInfo, this.currentEnvironment, false, this.showPointsScoreCard, false);
    }

    private updateStatistics() {
        $('.RewardUseModal').modal('hide');
        // this.disabledButton = false;
        // update analytics data layer
        if (!this.disableToastmessageRewardPage) {
            const pointsString = this.reward.pointsRequired > 1 ? ' Points.' : ' Point.';
            let toasterArgs = {
                message: 'Used ' + this.reward.pointsRequired + pointsString,
                type: RewardsToasterType.Success,
            }
            this.createToast(toasterArgs);
        }
        if (localStorage.getItem('abCoupons')) {
            let allCoupons = JSON.parse(localStorage.getItem('abCoupons'));
            if (allCoupons && allCoupons.offers) {
                for (let offerId in allCoupons.offers) {
                    let coupon = allCoupons.offers[offerId];
                    if (coupon.offerTs == this.reward.offerTs) {
                        let couponInfo = {
                            brand: coupon.brand,
                            offerType: coupon.offerPgm,
                            offerId: coupon.offerId,
                            offerPrice: coupon.offerPrice,
                            carouselSection: this.reward.rewardsRequired + " Rewards"
                        };
                        window['AB']['DATALAYER'].analyticsCouponUpdate(couponInfo);
                    }
                }
            }
        }

    }

    public clipRewardMulticlip(reward: RewardModel) {
        this.couponClipFn.clipReward(reward, this.updateStatisticsMulticlip.bind(this, reward), this.rewardNewRefreshDisabled, this.userInfo, this.currentEnvironment, false, this.showPointsScoreCard, false);
    }

    public clipRewardNonRefund() {
        if(this.rewardPageType && this.rewardPageType === 'reward-detail'){
            this.isClipInProgress = true;
            this.clipInProgressForDetailsPage.emit(this.modal.reward);

        } else {
            if (!this.disableToastmessageRewardPage) {
                const pointsString = this.reward.pointsRequired > 1 ? ' Points.' : ' Point.';
                let toasterArgs = {
                    message: 'Used ' + this.reward.pointsRequired + pointsString,
                    type: RewardsToasterType.SuccessGoToRewards,
                    continueCb: () => this.openRewardsModal()
                }
                this.setLocalStorageForToaster(toasterArgs);
            }
            this.clipReward();
        }
    }

    public openRewardsModal() {
        this.couponClipFn.openRewardsModalSource.next(true);
    }

    public clipRewardMulticlipNonRefund(reward: RewardModel) {
        if (this.rewardPageType && this.rewardPageType === 'reward-detail') {
            this.isClipInProgress = true;
            this.clipInProgressForDetailsPage.emit(reward);
        } else {
            if (!this.disableToastmessageRewardPage) {
                const pointsString = this.reward.pointsRequired > 1 ? ' Points.' : ' Point.';
                let toasterArgs = {
                    message: 'Used ' + this.reward.pointsRequired + pointsString,
                    type: RewardsToasterType.SuccessGoToRewards,
                    continueCb: () => this.openRewardsModal()
                }
                this.setLocalStorageForToaster(toasterArgs);
            }
            this.clipRewardMulticlip(reward);
        }
    }

    public setLocalStorageForToaster(toasterArgs: any) {
        if (localStorage.getItem('rewardClipAndUnclipToastData')) {
            localStorage.removeItem('rewardClipAndUnclipToastData');
        }
        localStorage.setItem('rewardClipAndUnclipToastData', JSON.stringify(toasterArgs));
    }

    public updateStatisticsMulticlip(reward: RewardModel) {
        if(this.isGetYourRewardFlow){
            this.callMyListApi.emit(true);
        } else {
            this.getSelectedRewardsMulticlip();
        }
        if (!this.disableToastmessageRewardPage) {
            const pointsString = reward.pointsRequired > 1 ? ' Points.' : ' Point.';
            let toasterArgs = {
                message: 'Used ' + reward.pointsRequired + pointsString,
                type: RewardsToasterType.Success,
            }
            this.createToast(toasterArgs);
        }

    }

    //Not used but have to be declared because they use the same html template
    public getSelectedRewards() {
        if (this._isRegistered() && this.modal.isRewardsRedemption) {
            //add class to active reward offer for ADA focus
            var activeId = this.modal.id;
            $('#' + activeId).closest('.reward-grid-itme').addClass('activeRewardsModal');

            this._pointsModalService
                .getSelectedRewardsOffers(this.userInfo, this.currentEnvironment)
                .subscribe(response => {
                    this.rewardsSelected = response;
                });
        }
    }

    public getSummaryData() {
        this._rewardsSummaryService.getData()
            .subscribe((data) => {
                if (typeof data != 'string') {
                    if (data.rewards) {
                        const rewards = data.rewards;
                        if (rewards == null || !rewards) {
                            this.rewardPoints = 0;
                            this.rewardsAvailable = 0;
                            this.rewardsExpire = 0;
                        } else if ((rewards != null || rewards) && rewards.hasOwnProperty('rewardPoints') && rewards.hasOwnProperty('rewardsAvailable') && rewards.hasOwnProperty('rewardsExpire')) {
                            this.rewardPoints = typeof rewards.rewardPoints == 'number' ? rewards.rewardPoints : 0;
                            if (this._rewardsSummaryService.useOrDeleteSummary()) {
                                let objRewardPoints = JSON.parse(localStorage.abRewardsSummary);
                                this.rewardsAvailable = objRewardPoints.rewardsAvailable;
                                this.rewardsExpire = objRewardPoints.rewardsExpire;

                            } else {
                                this.rewardsAvailable = typeof rewards.rewardsAvailable == 'number' ? rewards.rewardsAvailable : 0;
                                this.rewardsExpire = typeof rewards.rewardsExpire == 'number' ? rewards.rewardsExpire : 0;
                            }
                        }
                        this.rewardsSelected.forEach(reward => {
                            reward['rewardsAvailable'] = this.rewardsAvailable;
                            reward['rewardsExpire'] = this.rewardsExpire;
                        })
                    } else {
                        this.rewardPoints = 0;
                        this.rewardsAvailable = 0;
                        this.rewardsExpire = 0;
                        this.rewardsSelected.forEach(reward => {
                            reward['rewardsAvailable'] = this.rewardsAvailable;
                            reward['rewardsExpire'] = this.rewardsExpire;
                        })

                    }
                }
            }, error => {
                this.rewardPoints = 0;
                this.rewardsAvailable = 0;
                this.rewardsExpire = 0;
                this.rewardsSelected.forEach(reward => {
                    reward['rewardsAvailable'] = this.rewardsAvailable;
                    reward['rewardsExpire'] = this.rewardsExpire;
                })
            })
    }

    public getSelectedRewardsMulticlip() {
        if (this._isRegistered() && this.modal.isRewardsRedemption) {
            //add class to active reward offer for ADA focus
            var activeId = this.modal.id;
            $('#' + activeId).closest('.reward-grid-itme').addClass('activeRewardsModal');

            this._pointsModalService
                .getSelectedRewardsOffersMultiClip(this.userInfo, this.currentEnvironment)
                .subscribe(response => {
                    //    response.forEach(reward =>{
                    //     this.getSummaryData(reward);
                    //    })
                    this.rewardsSelected = response;
                    this.getSummaryData();
                });

        }
    }

    private clipByDateCheck(reward: RewardModel): boolean {

        /*
        sample date formats in 3 pages:
        "1/1/2023" gallery API
        "\\/Date(1893524400000)\\/" mylist API
        "2030-01-01" detail API
        */

        if (this.rewardPageType == "reward-detail") {
            let today = moment();
            let endDateString = reward.displayEndDate;
            let newdate = new Date(endDateString + 'T00:00');
            let rewardEndDate = moment(newdate).format('MM/DD/YYYY');
            return today.diff(rewardEndDate, 'days') <= 0;
        } else if (this.rewardPageType == "reward-modal") {
            let today = moment();
            let endDateString = reward.displayEndDate;
            let newdate = new Date(this._pointsModalService.dateConversion(endDateString));
            let rewardEndDate = moment(newdate).format('MM/DD/YYYY');
            return today.diff(rewardEndDate, 'days') <= 0;
        }
        // default on reward gallery page doesn't need to check - return true
        return true;
    }

    public unclipReward(reward: RewardModel, index: number) {
        // should call unclip api when the response comes back 200 and value of 1 then hide the reward from the array of  my list rewards temp  Set the isRefresh used to true
        if (this.modal.isRewardsSelected && reward.rewardsRefundable) {
            this.modal.isSafeToClose = false;
            this._pointsModalService
                .callUnclipAPI(reward, this.userInfo).subscribe(response => {
                this.rewardsUnclip = response;
                if (this.rewardsUnclip[0].status == 1) {
                    this.modal.isRefresh = true;
                    this.rewardsSelected.splice(index, 1);
                }
                if (this.rewardsUnclip[0].status != 1) {
                    this.rewardsSelected = null;
                    this.getSelectedRewards();
                    this.modal.isRefresh = true;
                }
                this.modal.isSafeToClose = true;
            })

        }
    }

    public simulateClick(event) {
        if (event.key == "Enter" || event.which == 13) {
            event.target.click();
        }
    }

    private set(key: string, data: any): void {
        try {
            localStorage.setItem(key, JSON.stringify(data));
        } catch (e) {
            console.error('Error saving to localStorage', e);
        }
    }

    private get(key: string) {
        try {
            return JSON.parse(localStorage.getItem(key));
        } catch (e) {
            console.error('Error getting data from localStorage', e);
            return null;
        }
    }


    public redrawAPI() {

        if (this.modal.isRefresh == true && this.modal.isSafeToClose == true) {
            this.isClipInProgress = false;
            if (this.rewardNewRefreshDisabled) {

                _window()['location']['href'] = '/foru/rewards.html';

            } else {

                const rewardGridOffers = this.get('abRewards');

                if (rewardGridOffers) {
                    rewardGridOffers.savedTime = '';
                    this.set('abRewards', rewardGridOffers);
                }
                this.couponClipFn.rewardsRefreshSource.next(true);
                this.sendNoteToRefreshRewards.emit(true);
                // window['AB'] && window['AB'].LOYALTY && window['AB'].LOYALTY.initRewardScorecard();
                $('.RewardUseModal').modal('hide');

            }

            this.modal.isRefresh = false;
        }
    }

    public getImageUrl(id: string, viewport: string): string {
        const modifiedImagePath = this.imagePath;
        return modifiedImagePath ? modifiedImagePath.replace('${product.id}', id).replace('${viewport}', viewport) : '';
    }

    private _isRegistered(): boolean {
        return (this.authService.isTokenValidForSession(this.userInfo));
    }

    private createToast(args: RewardsToasterArgs): void {
        let autoCloseTime = RewardsToasterService.autoCloseTime;
        if (args.type == RewardsToasterType.PartiallyExpired) {
            autoCloseTime = 0;
        }
        let toastElement: HTMLElement = this._rewardsToasterService.createToast(
            {message: args.message, type: args.type, autoCloseTime: RewardsToasterService.autoCloseTime},
            args.continueCb ? args.continueCb : () => {
            },
            args.closeCb ? args.closeCb : () => {
            },
            true
        );
        let contentElement = document.querySelector('.point-reward-grid-container');
        if (toastElement && contentElement) {
            this._renderer.appendChild(contentElement, toastElement);
        }
    }
}

